export default "__VITE_ASSET__695572d5__"